import * as yup from 'yup';

export const cardSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  outlet: yup.string().required('Outlet is required'),
  cardnumber: yup
    .string()
    .required('Card number is required')
    .matches(/^[0-9]{10,16}$/, 'Invalid card number'), // Assuming 16-digit credit card number
  // .test("luhn-algorithm", "Invalid card number", (value) => {
  //   // Luhn algorithm check for cards
  //   if (!value) return false;

  //   let sum = 0;
  //   let doubleUp = false;

  //   for (let i = value.length - 1; i >= 0; i--) {
  //     let digit = parseInt(value.charAt(i), 10);

  //     if (doubleUp) {
  //       digit *= 2;

  //       if (digit > 9) {
  //         digit -= 9;
  //       }
  //     }

  //     sum += digit;
  //     doubleUp = !doubleUp;
  //   }

  //   return sum % 10 === 0;
  // }),
  expirymonth: yup.string().required('This fields is required'),
  expiryyear: yup.string().required('This fields is required'),
  zipcode: yup
    .string()
    .matches(/^\d{5}(?:-\d{4})?$/, 'Invalid ZIP code')
    .required('Zipcode is required'),
});

export const bankSchema = yup.object().shape({
  routingnumber: yup
    .string()
    .required('Routing number is required')
    .matches(/^\d{9}$/, 'Invalid routing number'),
  outlet: yup.string().required('Outlet is required'),
  accountnumber: yup
    .string()
    .required('Account number is required')
    .matches(/^\d{6,}$/, 'Invalid account number'),
  firstname: yup.string().required('First name is required'),
  lastname: yup.string().required('Last name is required'),
  accounttype: yup.string().required('Account type is required'),
  state: yup.string().required('State is required'),
  zipcode: yup
    .string()
    .matches(/^\d{5}(?:-\d{4})?$/, 'Invalid ZIP code')
    .required('Zipcode is required'),
});
